import {
  Info as TheIcon
} from 'components/icons';

// OR
// import React from 'react';
// import { Icon } from "semantic-ui-react";

// function TheIcon (props) {
//   return <Icon name="info" {...props} />;
// }

export const meta = {
  id: 'CMSPageEditor',
  title: 'CMS Page Editor',
  category: 'CMS',
  exposes: [
    // {
    //   title: 'General',
    //   action: { module: 'CMSPageEditor', props: { /* */ } },
    //   desription: 'general-desc',
    // },
  ],
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `The page editor for the CMS`,
  windowOptions: {
    maximized: true
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
